<template>
    <div>
        <div class="search-box">
            <p>部门：</p>
            <a-tree-select
                class="input-box"
                showSearch
                v-model="selectedDeployment"
                labelInValue
                :treeData="departmentTree"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                allowClear
                treeNodeFilterProp="title"
                treeDefaultExpandAll
                @change="onChangeDep"
                >
            </a-tree-select>
            <p>学历：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.highestEducationCode">
                <a-select-option v-for="(item,index) in xlArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>职称：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.technicalTitleCode">
                <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>研究方向：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.subjectDirectionCode">
                <a-select-option v-for="(item,index) in xkfxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>人员类别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.staffCategoryCode">
                <a-select-option v-for="(item,index) in rylbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <br />
            <p>性别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.genderCode">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>教师姓名/编号：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <p>是否在职：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.onJob">
                <a-select-option :value="true">是</a-select-option>
                <a-select-option :value="false">否</a-select-option>
            </a-select>
            <p>年龄：</p>
            <a-input-group compact class="input-box">
                <a-input style="text-align: center" v-model="searchFrom.startAge"/>
                <a-input
                    style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                    placeholder="~"
                    disabled
                />
                <a-input style="text-align: center; border-left: 0"  v-model="searchFrom.endAge"/>
            </a-input-group>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <a-button v-if="permissions.indexOf('faculty:teacher:export')>-1" type="primary" icon="download" class="right-btn" @click="exportTable" >导出Excel</a-button>
            <a-button type="primary" v-if="permissions.indexOf('faculty:teacher:add')>-1" icon="plus" class="right-btn" @click="$router.push('/admin/faculty/teacher/info?type=add')">新增</a-button>
        </div>
        <a-table 
            rowKey="id"
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            
            <template slot="highestDegreeOrg" slot-scope="text,res">
                <span>{{text}}{{text==''?'':'('+res.highestEducationName+')'}}</span>
            </template>
            <template slot="id" slot-scope="text">
                <a class="action-btn" v-if="permissions.indexOf('faculty:teacher:query')>-1" @click="$router.push('/admin/faculty/teacher/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" v-if="permissions.indexOf('faculty:teacher:edit')>-1" @click="$router.push('/admin/faculty/teacher/info?type=update&id='+text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    v-if="permissions.indexOf('faculty:teacher:delete')>-1"
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,exportTable } from '@/baseAPI/facultyTeacher'
    import { queryDepartmentTreeList } from '@/baseAPI/department'
    const columns = [
        {
            title: '序号',
            dataIndex: 'createTime',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '工号',
            dataIndex: 'teacherId',
            align:'center',
            sorter:true,
        },
        {
            title: '人员类别',
            dataIndex: 'staffCategoryName',
            align:'center',
        },
        {
            title: '部门',
            dataIndex: 'orgName',
            align:'center',
            sorter:true,
        },
        {
            title: '姓名',
            dataIndex: 'teacherName',
            align:'center',
            sorter:true,
        },
        {
            title: '职称',
            dataIndex: 'technicalTitleName',
            align:'center',
            sorter:true,
        },
        {
            title: '性别',
            dataIndex: 'genderName',
            align:'center',
            sorter:true,
        },
        {
            title: '出生年月',
            dataIndex: 'birthday',
            align:'center',
            sorter:true,
        },
        {
            title: '最后毕业学校',
            dataIndex: 'highestDegreeOrg',
            align:'center'
        },
        {
            title: '学历',
            dataIndex: 'highestEducationName',
            align:'center'
        },
        {
            title: '入校时间',
            dataIndex: 'entryDate',
            align:'center',
            sorter:true,
        },
        {
            title: '考核',
            // dataIndex: 'phone',
            align:'center',
        },
        {
            title: '海外经历',
            dataIndex: 'hasOverseaExp',
            align:'center',
            customRender: (text) => {
                return text?{ children: '是'}:{ children: '否'};
            },
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSizeOptions: ['10', '20', '30', '50', '100'],
                    showSizeChanger:true,
                    showTotal:total=>'共'+total+'条数据',
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    genderCode:'',
                    onJob:'',
                    orgCode:'',
                    highestEducationCode:'',
                    technicalTitleCode:'',
                    subjectDirectionCode:'',
                    startAge:'',
                    endAge:'',
                    sortField:'',
                    sortOrder:'',
                    staffCategoryCode:'',
                },
                xbArr:[],
                xkfxArr:[],
                zcArr:[],
                xlArr:[],
                departmentTree:[],
                selectedDeployment:{},
                selectedRowKeys: [], 
                rylbArr:[],
                permissions:[]
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            queryDepartmentTreeList().then(res => {
                this.departmentTree = res.data
            })
            getDicts({dataCode:'XB',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'XKFX',status:true}).then(res=>{
                this.xkfxArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'XL',status:true}).then(res=>{
                this.xlArr=res.data.dicts;
            })
            getDicts({dataCode:'RYLB',status:true}).then(res=>{
                this.rylbArr=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination, filters, sorter){
                if(typeof sorter.order!='undefined'){
                    this.searchFrom.sortField=sorter.field
                    this.searchFrom.sortOrder=sorter.order.replace('end','')
                }else{
                    this.searchFrom.sortField=''
                    this.searchFrom.sortOrder=''
                }
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                pager.pageSize = pagination.pageSize;
                this.pagination = pager;
                console.log(this.pagination)
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.pageSizeOptions[4]=res.data.total+'';
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除人事信息成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            onChangeDep (obj) {
                this.selectedDeployment=obj;
                if(obj){
                    this.searchFrom.orgCode = obj.value;
                }else{
                    this.searchFrom.orgCode = '';
                }
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            exportTable(){
                var obj=this.deepCopy(this.searchFrom);
                delete obj.size;
                delete obj.current;
                obj.idList=this.selectedRowKeys;
                exportTable(obj).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 15px;
    }
    .search-box p
    {
        display: inline-block;
        width: 5rem;
        text-align: right;
    }
    .search-box p:nth-child(1),
    .search-box p:nth-child(12){
        width: auto;
    }
    .search-box p:nth-child(3),
    .search-box p:nth-child(14){
        width: 8rem;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
        margin-bottom: 1rem;
        display: inline-block;
        vertical-align: top;
    }
    .search-box .input-box .ant-input{
        display: inline-block;
        width: calc(50% - 15px);
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

</style>
